export const DEFAULT_FREE_DELIVERY_MIN = 499
export const DEFAULT_STANDARD_SHIPPING = 49

export function parseMoneySetting(value: string | undefined | null, fallback: number): number {
  const n = Number(value)
  return Number.isFinite(n) && n >= 0 ? n : fallback
}

export function shippingAmountForSubtotal(
  subtotal: number,
  freeDeliveryMin = DEFAULT_FREE_DELIVERY_MIN,
  standardShipping = DEFAULT_STANDARD_SHIPPING,
): number {
  if (subtotal >= freeDeliveryMin) return 0
  return standardShipping
}
